(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/image-helpers/assets/javascripts/image-provider.js') >= 0) return;  svs.modules.push('/components/onboarding/image-helpers/assets/javascripts/image-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useRef = _React.useRef,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useState = _React.useState,
  forwardRef = _React.forwardRef;
const ImageContext = svs.components.onboarding.imageHelpers.ImageContext;

const createImage = src => forwardRef((props, ref) => {
  const imgProps = _objectSpread(_objectSpread({}, props), {}, {
    src
  });
  return React.createElement("img", _extends({}, imgProps, {
    ref: ref
  }));
});
const createLazyImage = (src, loadedPromise) => forwardRef((props, ref) => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageLoaded = _useState2[0],
    setImageLoaded = _useState2[1];
  if (!imageLoaded) {
    loadedPromise
    .then(() => {
      setImageLoaded(true);
    })
    .catch(() => {
    });
    return null;
  }
  const imgProps = _objectSpread(_objectSpread({}, props), {}, {
    src
  });
  const Img = createImage(src);
  return React.createElement(Img, _extends({}, imgProps, {
    ref: ref
  }));
});
const createSignal = () => {
  let trigger;
  const p = new Promise(resolve => {
    trigger = () => {
      resolve();
    };
  });
  return [p, trigger];
};
const ImageProvider = _ref => {
  let children = _ref.children;
  const imageQueue = useRef(new Map());
  const loadImageIntoRef = useCallback(src => {
    if (!imageQueue.current.has(src)) {
      const _createSignal = createSignal(),
        _createSignal2 = _slicedToArray(_createSignal, 2),
        loadedPromise = _createSignal2[0],
        triggerLoaded = _createSignal2[1];
      imageQueue.current.set(src, {
        src,
        loadedPromise,
        triggerLoaded
      });
    }
    return imageQueue.current.get(src).loadedPromise;
  }, []);
  const state = useMemo(() => ({
    useLazyImage: (src, shouldOptOut) => shouldOptOut ? createImage(src) : createLazyImage(src, loadImageIntoRef(src))
  }), [loadImageIntoRef]);
  useEffect(() => {
    const requestId = window.requestIdleCallback(() => {
      const loadImage = src => new Promise(resolve => {
        const image = new Image();
        image.onload = () => {
          resolve(image);
        };
        image.src = src;
      });
      const workImageQueue = async imageIterator => {
        const imageEntry = imageIterator.next();
        if (!imageEntry.done) {
          const _imageEntry$value$ = imageEntry.value[1],
            src = _imageEntry$value$.src,
            triggerLoaded = _imageEntry$value$.triggerLoaded;
          await loadImage(src);
          triggerLoaded();
          workImageQueue(imageIterator);
        } else if (imageQueue.current.size > 0) {
          const _imageQueue = new Map(imageQueue.current);
          imageQueue.current = new Map();
          workImageQueue(_imageQueue.entries());
        }
      };
      const processQueue = () => {
        const _imageQueue = new Map(imageQueue.current);
        imageQueue.current = new Map();
        workImageQueue(_imageQueue.entries());
      };
      processQueue();
    });
    return () => {
      window.cancelIdleCallback(requestId);
    };
  }, []);
  return React.createElement(ImageContext.Provider, {
    value: state
  }, children);
};
setGlobal('svs.components.onboarding.imageHelpers.ImageProvider', ImageProvider);

 })(window);